<div class="modal-header" id="measurement-tools-modal-title">
    <h3 class="modal-title" id="modal-title" translate="DASHBOARD_SIDEMENU_MEASUREMENT_TOOLS_TITLE"></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body">
    <div class="table-responsive">
        <table class="table table-hover mb-0">
            <thead>
                <tr class="bg-light">
                    <th class="col-12 col-lg-4 text-start" (click)="setOrderBy('descriptionDropdownText')">
                        <span translate="DASHBOARD_SIDEMENU_MEASUREMENT_TOOLS_DESCRIPTION"></span>
                        <span
                            class="ms-2 small"
                            [hidden]="fieldName !== 'descriptionDropdownText'"
                            [ngClass]="reverse ? 'bi bi-caret-down-fill' : 'bi bi-caret-up-fill'"
                        ></span>
                    </th>
                    <th class="col-lg-3 text-start d-none d-lg-table-cell" (click)="setOrderBy('technicalId')">
                        <span translate="DASHBOARD_SIDEMENU_MEASUREMENT_TOOLS_TID"></span>
                        <span
                            class="ms-2 small"
                            [hidden]="fieldName !== 'technicalId'"
                            [ngClass]="reverse ? 'bi bi-caret-down-fill' : 'bi bi-caret-up-fill'"
                        ></span>
                    </th>
                    <th class="col-lg-3 text-start d-none d-lg-table-cell" (click)="setOrderBy('calibratedDate')">
                        <span translate="DASHBOARD_SIDEMENU_MEASUREMENT_TOOLS_CALIBRATED_UNTIL"></span>
                        <span
                            class="ms-2 small"
                            [hidden]="fieldName !== 'calibratedDate'"
                            [ngClass]="reverse ? 'bi bi-caret-down-fill' : 'bi bi-caret-up-fill'"
                        ></span>
                    </th>
                    <th class="col-lg-2 text-start d-none d-lg-table-cell" (click)="setOrderBy('gid')">
                        <span translate="DASHBOARD_SIDEMENU_MEASUREMENT_TOOLS_GID"></span>
                        <span
                            class="ms-2 small"
                            [hidden]="fieldName !== 'gid'"
                            [ngClass]="reverse ? 'bi bi-caret-down-fill' : 'bi bi-caret-up-fill'"
                        ></span>
                    </th>
                </tr>
            </thead>
            <tbody class="overflow-auto vh-65">
                <tr class="text-center" *ngIf="isMeasurementToolsEmpty">
                    <td colspan="4" class="py-4">{{ measurementTools[0].message }}</td>
                </tr>

                <ng-container *ngIf="!isMeasurementToolsEmpty">
                    <ng-container *ngFor="let measurementTool of measurementTools | orderBy: fieldName : reverse">
                        <tr [ngClass]="{ 'ng-invalid': measurementTool.isToolInvalid() }">
                            <td class="col-12 col-lg-4 text-start">
                                <div class="d-flex align-items-center justify-content-between">
                                    <span class="text-truncate pe-2">{{
                                        measurementTool.descriptionDropdownText
                                    }}</span>
                                    <button
                                        class="btn btn-link d-lg-none p-1 ms-auto text-primary"
                                        (click)="toggleCollapse(measurementTool)"
                                        [attr.aria-label]="
                                            (measurementTool.isCollapsed
                                                ? 'DASHBOARD_SIDEMENU_MEASUREMENT_TOOLS_SHOW_DETAILS'
                                                : 'DASHBOARD_SIDEMENU_MEASUREMENT_TOOLS_HIDE_DETAILS'
                                            ) | translate
                                        "
                                    >
                                        <fa-icon
                                            [icon]="measurementTool.isCollapsed ? faChevronDown : faChevronUp"
                                        ></fa-icon>
                                    </button>
                                </div>
                            </td>
                            <td class="col-lg-3 text-start d-none d-lg-table-cell">
                                {{ measurementTool.technicalId }}
                            </td>
                            <td class="col-lg-3 text-start d-none d-lg-table-cell">
                                {{ measurementTool.calibratedDate | formatDate }}
                            </td>
                            <td class="col-lg-2 text-start d-none d-lg-table-cell">{{ measurementTool.gid }}</td>
                        </tr>
                        <tr class="d-lg-none" [class.d-none]="measurementTool.isCollapsed">
                            <td colspan="4" class="bg-light border-top-0 p-3">
                                <div class="row g-2">
                                    <div class="col-12">
                                        <div class="d-flex">
                                            <div class="col-5">
                                                <strong translate="DASHBOARD_SIDEMENU_MEASUREMENT_TOOLS_TID"></strong>
                                            </div>
                                            <div class="col-7">{{ measurementTool.technicalId }}</div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="d-flex">
                                            <div class="col-5">
                                                <strong
                                                    translate="DASHBOARD_SIDEMENU_MEASUREMENT_TOOLS_CALIBRATED_UNTIL"
                                                ></strong>
                                            </div>
                                            <div class="col-7">{{ measurementTool.calibratedDate | formatDate }}</div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="d-flex">
                                            <div class="col-5">
                                                <strong translate="DASHBOARD_SIDEMENU_MEASUREMENT_TOOLS_GID"></strong>
                                            </div>
                                            <div class="col-7">{{ measurementTool.gid }}</div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                </ng-container>
            </tbody>
        </table>
    </div>
</div>
